module.exports = __webpack_public_path__ + "img/color-1@2x.e2c33fa.png";